<template>
  <div class="image-container" style="line-height: 1.8">
    <el-carousel height="100vh" motion-blur>
      <el-carousel-item v-for="(item,index) in images" :key="index">
        <el-image
            class="part1-picture animated"
            style="width: 100%; height: 100%;"
            :src="item"
            fit="cover"
        />

      </el-carousel-item>
    </el-carousel>
    <div class="part1-picture-content">
      <div class="gothamMedium">
        DINGAIXIN TECHNOLOGY
      </div>
      <div style="color: white;margin-top: 3rem; margin-bottom: 3rem;">
        标准化、信息化、智能化、自动化加工<br/>
        行业领先的智慧传动工
      </div>

      <div id="part1-picture-button-div"
           style="display: flex; align-items: center; justify-content: flex-start;text-align: center;">

        <div class="part1-picture-button"
             @click="$emit('route_jump',{'route':'company_profile'})">
          <span style="width: 6rem">
            探索更多
          </span>

          <span style="display: flex; align-items: center;text-align: center;justify-content: center;">
            <svg t="1734519876565" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
                 style="color: white"
                 p-id="4209" width="1.5rem" height="1.5rem">
              <path d="M398.499 236.5l274.256 274.25599999-274.25600001 274.25600001z" p-id="4210"></path>
            </svg>
          </span>
        </div>


        <div class=" part1-picture-button"
             @click="$emit('route_jump',{'route':'news'})">
          <span style="width: 6rem">
            了解最新
          </span>

          <span style="display: flex; align-items: center;text-align: center;justify-content: center;">
            <svg t="1734519876565" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
                 style="color: white"
                 p-id="4209" width="1.5rem" height="1.5rem">
              <path d="M398.499 236.5l274.256 274.25599999-274.25600001 274.25600001z" p-id="4210"></path>
            </svg>
          </span>
        </div>

      </div>
    </div>
    <div class="scroll-hint">
      <span>Scroll</span>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";

const indexPicturePart1 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/index_1.jpg";
const images = ref([indexPicturePart1, indexPicturePart1])

</script>

<style scoped>
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.part1-picture-content {
  position: absolute;
  top: 30%;
  left: 6%;
  color: #a6dc1c;
  font-size: 4rem;
  text-align: left;
  padding: 0.8rem 1.2rem;
  border-radius: 5px;
}

.part1-picture-content > div:nth-of-type(2) {
  font-size: 1.5rem;
}

.part1-picture-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 10rem;
  border: white 1px solid;
  color: white;
  font-size: 1rem;
  align-self: center;
  margin-right: 2rem;
}

/* 动画样式 */
.animated {
  animation: pictureInOut 1s ease-in-out;
}

@keyframes pictureInOut {
  0% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

#app > div.page-container.puHuiTi-Medium > div.page > div > div.el-carousel.el-carousel--horizontal > /deep/ ul {
  left: 10% !important;
  bottom: 20% !important;
}

.part1-picture-button > span:nth-of-type(2) {
  width: 2rem;
  height: 3rem;
  border-left: white 1px solid;
  margin-right: 0;

}

.part1-picture-button:hover {
  background-color: white;
  color: #003795;
}

.part1-picture-button:hover > span:nth-of-type(2) {
  border-left: #003795 1px solid;

}

.part1-picture-button svg {
  fill: white;
}

.part1-picture-button:hover svg {
  fill: #003795; /* Hover 状态下改变颜色 */
}


.scroll-hint {
  position: absolute; /* 绝对定位 */
  bottom: 3rem; /* 距离底部 10px */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9999; /* 设置 z-index，保证文字在最上层 */
  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */
  color: white;
}

.scroll-hint span {
  /*writing-mode: vertical-rl; !* 设置为竖向文字 *!*/
  text-orientation: upright;
  font-size: 1.2rem;
  font-weight: bold;
  white-space: nowrap; /* 禁止换行 */
  transform: rotate(270deg); /* 旋转文字90度 */

}

.scroll-hint::after {
  content: "↓"; /* 添加箭头 */
  font-size: 1.5rem;
  animation: smooth-bounce 2s infinite;
  margin-top: 1.2rem;
}



</style>
